import i18n from "@/localization/i18n";

const HOMEPAGE_BASE_URL = "https://www.egetrans.com";

export enum HomepageSubPage {
  HOMEPAGE,
  IMPRINT,
  PRIVACY_POLICY,
  TERMS_OF_SERVICE,
  CONTACT,
}

const SUPPORTED_LOCALES = ["en", "de", "es"] as const;

type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

const DEFAULT_LOCALE: SupportedLocale = "en";

type LocalizedSubPage = Record<SupportedLocale, string>;

const subPages: Record<HomepageSubPage, LocalizedSubPage> = {
  [HomepageSubPage.HOMEPAGE]: {
    en: "",
    de: "",
    es: "",
  },
  [HomepageSubPage.IMPRINT]: {
    en: "legalnotice",
    de: "impressum",
    es: "avisolegal",
  },
  [HomepageSubPage.PRIVACY_POLICY]: {
    en: "privacy",
    de: "datenschutz",
    es: "avisodeprivacidad",
  },
  [HomepageSubPage.TERMS_OF_SERVICE]: {
    en: "termsandconditions",
    de: "agb",
    es: "terminosycondiciones",
  },
  [HomepageSubPage.CONTACT]: {
    en: "contact",
    de: "kontakt",
    es: "contacto",
  },
};

export const useHomepageLink = (): {
  getHomepageLink: (subPage: HomepageSubPage) => string;
} => {
  const { locale } = i18n.global;

  const getHomepageLink = (subPage: HomepageSubPage): string => {
    const localeString = locale.value;

    if ((SUPPORTED_LOCALES as ReadonlyArray<string>).includes(localeString)) {
      return `${HOMEPAGE_BASE_URL}/${localeString}/${
        subPages[subPage][localeString as SupportedLocale]
      }`;
    } else {
      return `${HOMEPAGE_BASE_URL}/${DEFAULT_LOCALE}/${subPages[subPage][DEFAULT_LOCALE]}`;
    }
  };

  return { getHomepageLink };
};
